import { ControlList, useFormData, useUrlParamsValue, useUrlParamsValueToString } from "@bsm/component";
import { useNavigate, useParams } from "react-router-dom";
import { useTimeOffControlForm } from "../hooks/useTimeOffControlForm";
import { useTimeOffInvalidateQuery } from "hooks/useTimeOffInvalidateQuery";
import { useProjectTimeOffNavigateBack } from "views/create/hooks/useProjectTimeOffNavigateBack";
import { useCountSoldMutation } from "hooks/useCountSoldMutation";
import { useBulkTimeOffControlForm } from "../hooks/useBulkTimeOffControlForm";
import { useValidateBulkTimeoffCreationMutation } from "../hooks/useValidateBulkTimeoffCreationMutation";

const ProjectTimeOffCreateLeavingContainer = () => {

    const { id } = useParams();

    const { formData } = useFormData<any>({
        id: "timeoff-add-leaving-form",
        formData: {}
    });

    const urlParams = useUrlParamsValue()
    const urlParamsToString = useUrlParamsValueToString()
    const bulkControl = useBulkTimeOffControlForm()
    const control = useTimeOffControlForm(id ? parseInt(id) : undefined, formData?.type);
    const invalidateTimeOffsQuery = useTimeOffInvalidateQuery()
    const navigateBack = useProjectTimeOffNavigateBack()
    const navigate = useNavigate()
    const countSoldMutation = useCountSoldMutation()
    const validateBulkTimeoffCreationMutation = useValidateBulkTimeoffCreationMutation()

    const handleSubmited = (val) => {

        if(formData?.type === 'ABSENCE') {
            countSoldMutation.mutate(val?.id)
        }

        if (urlParams?.bulk) {
          validateBulkTimeoffCreationMutation.mutate(
            { ids: val.ids },
          );
        }

        invalidateTimeOffsQuery()
        navigateBack();
    };

    return (
        <ControlList
            {...(urlParams.bulk ? bulkControl : control)}
            defaultValue={{
                dateBegin: urlParams?.eventDate,
                employee: urlParams?.employeeFilterCalendar && !urlParams?.bulk ? { id: urlParams?.employeeFilterCalendar } : undefined
            }}
            id="timeoff-add-leaving-form"
            onSubmited={handleSubmited}
            onCancel={() => {
                const params = new URLSearchParams(urlParamsToString);
                if (params.has('bulk')) {
                    params.delete('bulk');
                }
                navigate(-1)
            }}
        />
    );
};

export default ProjectTimeOffCreateLeavingContainer;

